import axios from 'axios';
import store from '../redux/store';
import { LOGOUT } from '../redux/action_types';

// const api = axios.create({
//   baseURL: 'https://metafomosbackend.herokuapp.com/api',
//   headers: {
//     'Content-Type': 'application/json'
//   }
// });

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

/**
 intercept any error responses from the api
 and check if the token is no longer valid.
 ie. Token has expired or user is no longer
 authenticated.
 logout the user if the token has expired
**/

api.interceptors.response.use(
  (res:any) => res,
  (err:any) => {
    if (err.response.status === 401) {
      store.dispatch({ type: LOGOUT });
    }
    return Promise.reject(err);
  }
);

export default api;
